module.exports = __webpack_public_path__ + "img/barva-zakladni_81_sharp-zelena.fa2d9b56.png";